import { useEffect, useRef } from 'react';

interface SakuraPetal {
  x: number;
  y: number;
  radius: number;
  speed: number;
  wind: number;
  opacity: number;
  rotation: number;
  rotationSpeed: number;
}

const SakuraEffect = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const setCanvasSize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    setCanvasSize();
    window.addEventListener('resize', setCanvasSize);

    const petals: SakuraPetal[] = [];
    const petalCount = 80;

    for (let i = 0; i < petalCount; i++) {
      petals.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 3 + 2,
        speed: Math.random() * 0.8 + 0.3,
        wind: Math.random() * 0.8 - 0.4,
        opacity: Math.random() * 0.5 + 0.3,
        rotation: Math.random() * Math.PI * 2,
        rotationSpeed: Math.random() * 0.02 - 0.01,
      });
    }

    const drawPetal = (petal: SakuraPetal) => {
      ctx.save();
      ctx.translate(petal.x, petal.y);
      ctx.rotate(petal.rotation);
      
      ctx.beginPath();
      ctx.ellipse(0, 0, petal.radius * 1.5, petal.radius, 0, 0, Math.PI * 2);
      
      const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, petal.radius * 1.5);
      gradient.addColorStop(0, `rgba(255, 182, 193, ${petal.opacity})`);
      gradient.addColorStop(0.5, `rgba(255, 192, 203, ${petal.opacity * 0.8})`);
      gradient.addColorStop(1, `rgba(255, 228, 225, ${petal.opacity * 0.4})`);
      
      ctx.fillStyle = gradient;
      ctx.fill();
      
      ctx.restore();
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      petals.forEach((petal) => {
        drawPetal(petal);

        petal.y += petal.speed;
        petal.x += petal.wind;
        petal.rotation += petal.rotationSpeed;

        if (petal.y > canvas.height) {
          petal.y = -10;
          petal.x = Math.random() * canvas.width;
        }

        if (petal.x > canvas.width) {
          petal.x = 0;
        } else if (petal.x < 0) {
          petal.x = canvas.width;
        }
      });

      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', setCanvasSize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none z-40"
      style={{ mixBlendMode: 'screen' }}
    />
  );
};

export default SakuraEffect;
